import React, { useState, useEffect, useMemo, useRef } from "react";
import CdrService from "../apiservices/CdrService";
import { useTable, usePagination } from "react-table";
import { ThemeProvider } from "@mui/styles";
import { CSVLink, CSVDownload } from "react-csv";
import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css

import "./cdr.css";

import {
  Divider,
  Datepicker,
  Dropdown,
  Button,
  TextArea,
  Input,
} from "@fluentui/react-northstar";
import { Icon } from "@fluentui/react/lib/Icon";

import { HiDownload } from "react-icons/hi";
import { ImArrowUpRight2, ImArrowDownRight2 } from "react-icons/im";
import { FaPlay, FaSadCry } from "react-icons/fa";

import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";

import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";

const theme = {
  background: "black",
};

const Cdr = () => {
  const [showCdr, setShowCdr] = useState(false);
  const [tutorials, setTutorials] = useState([]);
  const tutorialsRef = useRef();
  const [initDate, setInitDate] = useState(new Date());
  const [finDate, setFinDate] = useState(new Date());
  const [iniMonthSelected, setIniMonthSelected] = useState(
    new Date().getMonth()
  );
  const [finMonthSelected, setFinMonthSelected] = useState(
    new Date().getMonth()
  );
  const [inboundSelected, setInboundSelected] = useState(false);
  const [outboundSelected, setOutboundSelected] = useState(false);
  const [attendedSelected, setAttendedSelected] = useState(false);
  const [nonAttendedSelected, setNonAttendedSelected] = useState(false);
  const [numberFiltered, setnumberFiltered] = useState(`""`);

  const [colorOutboundSelected, setColorOutboundSelected] = useState("white");
  const [colorInboundSelected, setColorInboundSelected] = useState("white");
  const [colorAttendedSelected, setColorAttendedSelected] = useState("white");
  const [colorNonAttendedSelected, setColorNonAttendedSelected] =
    useState("white");

  const selectedInitDate = async (date) => {
    setInitDate(date);
    setIniMonthSelected(date.getMonth());
  };

  const selectedFinDate = async (date) => {
    setFinDate(date);
    setFinMonthSelected(date.getMonth());
  };

  function padTo2Digits(num) {
    return num.toString().padStart(2, "0");
  }

  function formatDate(date) {
    return [
      padTo2Digits(date.getMonth() + 1),
      padTo2Digits(date.getDate()),
      date.getFullYear(),
    ].join("-");
  }

  const [filteredCDR, setfilteredCDR] = useState();
  const [loading, setLoading] = useState(false);

  const inputItems = [10, 20];
  const username = sessionStorage.getItem("userName");
  const companyy = sessionStorage.getItem("company");
  tutorialsRef.current = tutorials;

  function getToken() {
    const tokenString = sessionStorage.getItem("tokenStats");
    return tokenString;
  }

  useEffect(() => {}, []);

  const retrieveAllCdr = () => {
    var token = getToken();
    var initDate1 = formatDate(initDate);
    var endDate1 = formatDate(finDate);

    if (
      inboundSelected === true ||
      outboundSelected === true ||
      attendedSelected === true ||
      nonAttendedSelected === true ||
      numberFiltered !== ""
    ) {
      CdrService.getAll(initDate1, endDate1, token, username, companyy, {
        inboundSelected: inboundSelected,
        outboundSelected: outboundSelected,
        attendedSelected: attendedSelected,
        nonAttendedSelected: nonAttendedSelected,
        numberFiltered: numberFiltered,
      })
        .then((response) => {
          setTutorials(response.data);
          setLoading(false);
        })
        .catch((e) => {
          console.log(e);
        });
    } else {
      CdrService.getAll(initDate1, endDate1, token, username, companyy, "")
        .then((response) => {
          setTutorials(response.data);
          setLoading(false);
        })
        .catch((e) => {
          console.log(e);
        });
    }
  };

  const showCdrToTrue = async () => {
    setShowCdr(false);
    setLoading(true);
    setTimeout(function () {
      if (iniMonthSelected === finMonthSelected) {
        setShowCdr(true);
        retrieveAllCdr();
      } else {
        setLoading(false);
        confirmAlert({
          title: "CAUTION!",
          message: `You can only filter calls within the same month`,
          buttons: [
            {
              label: "OK",
              onClick: () => window.location.reload(),
            },
          ],
        });
      }
    }, 1000);
  };
  const columns = useMemo(
    () => [
      {
        Header: "Type",
        accessor: "direction",
        Cell: (props) => {
          return (
            <div>
              {props.cell.value === "incoming" ? (
                <ImArrowDownRight2 />
              ) : (
                <ImArrowUpRight2 />
              )}
            </div>
          );
        },
      },
      {
        Header: "Date",
        accessor: "date",
      },
      {
        Header: "Duration (seconds)",
        accessor: "durationTime",
      },
      {
        Header: "Caller Number",
        accessor: "srcNumber",
      },
      {
        Header: "Caller Name",
        accessor: "srcName",
      },
      {
        Header: "Destination",
        accessor: "dstNumber",
      },
      {
        Header: "Entry Group",
        accessor: "dstName",
      },
      {
        Header: "Status",
        accessor: "queueResult",
      },
      {
        Header: "Receiving Agent",
        accessor: "queueAgent",
      },
      {
        Header: "Recording",
        accessor: "callRecording",
        Cell: (props) => {
          return (
            <div>
              <a
                style={{ textDecoration: "none", color: "inherit" }}
                href={props.cell.value}
              >
                <FaPlay />
              </a>
            </div>
          );
        },
      },
    ],
    []
  );

  const setInboundselectedToTrue = () => {
    setShowCdr(false);

    if (inboundSelected === false) {
      setInboundSelected(true);
      setColorInboundSelected("#797775");
      setfilteredCDR("(Filters applied)");
    } else {
      setInboundSelected(false);
      setColorInboundSelected("white");
      setfilteredCDR("");
    }
  };

  const setOutboundSelectedToTrue = () => {
    setShowCdr(false);

    if (outboundSelected === false) {
      setOutboundSelected(true);
      setColorOutboundSelected("#797775");
      setfilteredCDR("(Filters applied)");
    } else {
      setOutboundSelected(false);
      setColorOutboundSelected("white");
      setfilteredCDR("");
    }
  };

  const setAttendedSelectedToTrue = () => {
    setShowCdr(false);
    if (attendedSelected === false) {
      setAttendedSelected(true);
      setColorAttendedSelected("#797775");
      setfilteredCDR("(Filters applied)");
    } else {
      setAttendedSelected(false);
      setColorAttendedSelected("white");
      setfilteredCDR("");
    }
  };

  const setNonAttendedSelectedToTrue = () => {
    setShowCdr(false);

    if (nonAttendedSelected === false) {
      setNonAttendedSelected(true);
      setColorNonAttendedSelected("#797775");
      setfilteredCDR("(Filters applied)");
    } else {
      setNonAttendedSelected(false);
      setColorNonAttendedSelected("white");
      setfilteredCDR("");
    }
  };

  const {
    getTableProps,
    headerGroups,
    prepareRow,
    page,

    canPreviousPage,
    canNextPage,
    pageOptions,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns,
      data: tutorials,
      initialState: { pageIndex: 0, pageSize: 20 },
    },
    usePagination
  );

  return (
    <div className="cdrBody">
      <h1 className="h1">Call detail records</h1>
      <div className="divider">
        <Divider />
      </div>
      <h2 className="filtros"> Filters </h2>
      <div className="filterData">
        <div className="filteringDates">
          <h4>
            <Icon iconName="CalendarSettings" /> Date Range
          </h4>
          <div className="datePicker1">
            <Datepicker
              inputPlaceholder="Fecha inicial"
              today={new Date()}
              defaultSelectedDate={new Date()}
              onDateChange={(e, v) => {
                selectedInitDate(v.value);
              }}
            />
          </div>
          <div className="datePicker2">
            <Datepicker
              inputPlaceholder="Fecha final"
              today={new Date()}
              defaultSelectedDate={new Date()}
              onDateChange={(e, v) => {
                selectedFinDate(v.value);
              }}
            />
          </div>
        </div>
        <div className="filteringQueues">
          <h4>
            <Icon iconName="TransferCall" /> Call Type
          </h4>
          <div className="typeOfCall">
            <Button
              onClick={setInboundselectedToTrue}
              styles={{
                backgroundColor: colorInboundSelected,
              }}
              content="Inbound"
            />{" "}
            <Button
              onClick={setOutboundSelectedToTrue}
              styles={{
                backgroundColor: colorOutboundSelected,
              }}
              content="Outbound"
            />
          </div>
        </div>
        <div className="filteringAgents">
          <h4>
            <Icon iconName="StatusCircleCheckmark" /> Call Status
          </h4>
          <div className="selectAgents">
            <Button
              onClick={setAttendedSelectedToTrue}
              styles={{
                backgroundColor: colorAttendedSelected,
              }}
              content="Attended"
            />{" "}
            <Button
              onClick={setNonAttendedSelectedToTrue}
              styles={{
                backgroundColor: colorNonAttendedSelected,
              }}
              content="Non Attended"
            />
          </div>
        </div>
        <div className="filteringAgents">
          <h4>
            <Icon iconName="Filter" /> Filter by number
          </h4>
          <div className="selectAgents">
            <Input
              clearable
              onChange={(e, v) => {
                setnumberFiltered(v.value);
              }}
              placeholder="Ej: 900287287..."
            />
          </div>
        </div>
        {showCdr ? (
          <div className="filteringAgents">
            <h4>Download CDR {filteredCDR}</h4>
            <div className="selectAgents">
              <a>
                <CSVLink filename={"CDR_export"} data={tutorials}>
                  <img
                    src="https://static2.sharepointonline.com/files/fabric/assets/brand-icons/product/svg/excel_48x1.svg"
                    width="48"
                    height="48"
                    alt="Excel product icon"
                  />
                </CSVLink>
              </a>
            </div>
          </div>
        ) : (
          ""
        )}
      </div>
      <div>
        <br></br>
        <Button
          onClick={showCdrToTrue}
          loading={loading}
          primary
          content={loading ? "Applying Filters" : "Apply filters"}
        />
      </div>
      <br></br>

      {showCdr ? (
        <ThemeProvider theme={theme}>
          <Table
            sx={{
              fontFamily: "Segoe UI",
            }}
            {...getTableProps()}
          >
            <TableHead
              sx={{
                fontFamily: "Segoe UI",
                borderBottom: 1,
              }}
            >
              {headerGroups.map((headerGroup) => (
                <TableRow
                  sx={{
                    fontFamily: "Segoe UI",
                    borderBottom: 0,
                  }}
                  {...headerGroup.getHeaderGroupProps()}
                >
                  {headerGroup.headers.map((column) => (
                    <TableCell
                      sx={{
                        fontFamily: "Segoe UI",
                        borderBottom: 0,
                        fontWeight: "bold",
                        padding: 0,
                      }}
                      {...column.getHeaderProps()}
                    >
                      {column.render("Header")}
                    </TableCell>
                  ))}
                </TableRow>
              ))}
            </TableHead>
            <TableBody
              sx={{
                fontFamily: "Segoe UI",
              }}
            >
              {page.map((row, i) => {
                prepareRow(row);
                return (
                  <TableRow
                    sx={{
                      fontFamily: "Segoe UI",
                      borderBottom: 0,
                      "&:hover": {
                        color: "red",
                        backgroundColor: "#b3b0ad",
                      },
                    }}
                    {...row.getRowProps()}
                  >
                    {row.cells.map((cell) => {
                      return (
                        <TableCell
                          sx={{
                            fontFamily: "Segoe UI",
                            borderBottom: 0,

                            margin: 0,
                            padding: 0,
                          }}
                          {...cell.getCellProps()}
                        >
                          {cell.render("Cell")}
                        </TableCell>
                      );
                    })}
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
          <br></br>
          <div className="pagination">
            <Button
              size="small"
              content="Small"
              onClick={() => gotoPage(0)}
              disabled={!canPreviousPage}
            >
              {"<<"}
            </Button>{" "}
            <Button
              size="small"
              content="Small"
              onClick={() => previousPage()}
              disabled={!canPreviousPage}
            >
              {"<"}
            </Button>{" "}
            <Button
              size="small"
              content="Small"
              onClick={() => nextPage()}
              disabled={!canNextPage}
            >
              {">"}
            </Button>{" "}
            <Button
              size="small"
              content="Small"
              onClick={() => gotoPage(pageCount - 1)}
              disabled={!canNextPage}
            >
              {">>"}
            </Button>{" "}
            <span>
              Page{" "}
              <strong>
                {pageIndex + 1} of {pageOptions.length}
              </strong>{" "}
            </span>
            Rows show :
            <Dropdown
              value={pageSize}
              items={inputItems}
              placeholder="Select rows by page..."
              inline
              onChange={(e, { value }) => {
                setPageSize(Number(value));
              }}
            />
          </div>
        </ThemeProvider>
      ) : (
        ""
      )}
    </div>
  );
};

export default Cdr;
